<ol class="breadcrumb" *ngIf="router.url != '/'" style="margin-top: -15px">
  <li *ngIf="router.url != '/'" class="breadcrumb-item">
    <a
      [routerLink]="
        previousLinks.includes(router.url)
          ? '/xp/book-fcl'
          : '/xp/generate-pickup-request'
      "
      (click)="closeSubMenus()"
    >
      <i class="fa fa-home mr-2"></i>Home
    </a>
  </li>
  <li
    *ngFor="let breadcrumb of breadcrumbs; let i = index"
    class="breadcrumb-item"
  >
    <a [hidden]="i == breadcrumbs.length - 1" [routerLink]="[breadcrumb.url]">{{
      breadcrumb.name
    }}</a>
    <span [hidden]="i != breadcrumbs.length - 1"
      ><i *ngIf="router.url == '/'" class="fa fa-home mr-2"></i
      ><b>{{ breadcrumb.name }}</b></span
    >
  </li>
  <!-- Broadcast Message -->
<div class="broadcast-container">
  <div class="broadcast-text">
    🚨 The XP INDIA brand/logo will henceforth operate under Instant Transport Solution Private Limited, pursuant to the
    merger of Instant Supply Chain Solutions Private Limited (XP INDIA) with Instant Transport Solution Private
    Limited..
  </div>
</div>
</ol>


<!-- Mandatory Popup -->
<div class="popup-overlay" *ngIf="showMandatoryPopup">
  <div class="popup-box">

    <div class="popup-header">
      Important Update
    </div>

    <div class="popup-body">
      <p class="blue-text">
        Dear Valued Partner, Instant Supply Chain Solutions Pvt Ltd (XP India)
        has officially merged with our holding company,
        <b>Instant Transport Solution Pvt Ltd</b>, following approvals from the
        Regional Directorate (RD) and the Registrar of Companies (ROC).
      
        <span class="red-text">
          <b>XP INDIA</b> brand/logo will continue to operate under
          <b>Instant Transport Solution Private Limited.</b>
        </span>
      
        To ensure a seamless transition and prevent any disruptions to your
        daily vehicle dispatches and transit movements, kindly follow the new
        technical and billing updates effective from
        <span class="red-text"><b>1st August 2026</b></span>,
        which have been sent to your registered email IDs. You can also connect
        with your existing billing teams for any additional queries.
      </p>
    </div>

    <div class="popup-footer">
      <button class="btn btn-success" (click)="closePopup()">
        OK
      </button>
    </div>

  </div>
</div>